/**
 * Copyright (c) eventlint. All Rights Reserved.
 *
 *
 * @summary
 * @author Segev {CJ} Shmueli <cj@segevs.com>
 *
 * Created: 7/1/2022
 */

import { Typography } from '@mui/material';
import {
    FC,
    useRef,
} from 'react';
import data from '../data/product-updates.json';
import '../styles/updates.scss';


const VideoPreview: FC<{
    video: {
        id: string;
        source: string;
    }
}> = ({ video }) => {
    const ref = useRef<any>(null);
    const { id, source } = video;

    if (!id) {
        return null;
    }

    if (source === 'youtube') {
        return <div className='text-center flex justify-center py-4'>
            <iframe style={{
                maxWidth: 560,
                maxHeight: 315,
                aspectRatio: '560 / 315',
                width: '100%',
            }} src={`https://www.youtube.com/embed/${id}`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></div>;
    }

    // const [size, setSize] = useState<any>({ width: '100%' });
    const size = { width: '100%' };

    // const resetHeight = () => {
    //     if (ref.current?.offsetWidth) {
    //         setSize({ ...size, height: `${ref.current.offsetWidth / 1.2}px` });
    //     }
    // }


    // useEffect(() => {
    //     resetHeight();
    // }, [ref.current?.offsetWidth]);  



    return (
        <div ref={ref} className='video'>{video && <iframe title="screenshare" src={`https://www.loom.com/embed/${video}`} frameBorder="0" allowFullScreen={true} style={{ ...size }}></iframe>}</div>
    );
}

const ProductUpdates = () => {

    return (
        <>
            <div className='hero'>
                <h1>Product Updates</h1>
            </div>
            <main className='updates-list'>
                <div style={{
                    lineHeight: '1.85em',
                    background: '#fafafa',
                    border: '1px solid #e0e0e0',
                    padding: '1em',
                }}>
                    We recommend checking the page for updates weekly.
                    <br />
                    PLEASE DO NOT SHARE!! The demos are meant for sharing our progress with our advisors, some of the features are subject to change.
                </div>
                {data.updates.map((update: any, index) => {
                    const content = { __html: update.content.split('\n').join('<br />') };
                    return (
                        <div key={index} className="updates-item">
                            <div className='info'>
                                <Typography variant="h6" gutterBottom>{update.title}</Typography>
                                <div className='text-gray-500 italic text-sm'>{update.date}</div>
                                {update.video && <VideoPreview video={update.video} />}
                                <Typography variant='body1' lineHeight={1.75} dangerouslySetInnerHTML={content}></Typography>

                                {/* {update.links?.length > 0 && <div style={{fontSize:'.75em'}}>
                                    <h4 style={{paddingTop:20, fontWeight:'bold'}}>References</h4>
                                    <ul>
                                        {update.links.map((link: any, index: number) => <li key={index}><a href={link.url} target='_blank'>{link.text}</a></li>)}
                                    </ul>
                                </div>} */}
                            </div>
                        </div>
                    );
                })}

            </main>
        </>
    );
}
export default ProductUpdates;